export enum ErrorMessages {
  // Error Messages
  providedKeyEmpty = 'Provided key was null or empty',
  providedValueEmpty = 'Provided value was null or empty',
  unknownError = 'An unknown error occured',
  keyNotPresent = 'Provided Key was not present in Jarvis Value Store',
  optionsNotPresent = 'Provide entries/keys was null or empty'
}
